
import { TableRow } from "@/components/ui/table";
import { CompetitiveMetricRow } from "../CompetitiveMetricRow";
import { URLAnalysis } from "@/types/seo";

interface PositionMetricsProps {
  urlAnalyses: URLAnalysis[];
}

export const PositionMetrics = ({ urlAnalyses }: PositionMetricsProps) => (
  <>
    <CompetitiveMetricRow
      label="Posição no Google"
      description="Posição atual da página nos resultados orgânicos do Google para a palavra-chave alvo."
      analyses={urlAnalyses}
      getValue={(analysis) => analysis.position}
      getBestMetric={(value, bestValue) => {
        if (value === 0) return false;
        return typeof value === 'number' && (value < bestValue || bestValue === -Infinity);
      }}
    />

    <CompetitiveMetricRow
      label="Nota On-Page"
      description="Pontuação da otimização de conteúdo e elementos on-page da página."
      analyses={urlAnalyses}
      getValue={(analysis) => analysis.seo_score ? Math.round(analysis.seo_score) : null}
      getBestMetric={(value, bestValue) => typeof value === 'number' && value > bestValue}
    />
  </>
);
